var Marionette = require('backbone.marionette');

var DocumentTypeModel = require('../../models/document-type-model');
var EntitiesSelectView = require('../entities/entities-select');

var DocumentTypeFormView = Marionette.View.extend({
    template: require('../../templates/document-types/document-type-form.html'),

    regions: {
        organizations: "#organizations-list"
    },

    ui: {
        save: '#save',
        name: '#name',
        limit: '#limit',
        signX: '#sign-x',
        signY: '#sign-y',
        signWidth: '#sign-width',
        cancel: '#cancel'
    },

    events: {
        'click @ui.save': 'save',
        'click @ui.cancel': 'cancel',
        'keypress input[type=number]': 'onKeyPress'
    },

    childViewEvents: {
        'entity:selected': 'entitySelected'
    },

    templateContext: function () {
        return {
            title: this.mode == 'add' ? 'New document type' : "Edit document type",
            mode: this.mode == 'add' ? 'Add' : "Edit"
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'save', 'entitySelected', 'onRender', 'cancel', 'modelSaved', 'onKeyPress');
        this.mode = options.mode;
        if (this.mode == 'add') {
            this.model = new DocumentTypeModel();
        } else if (this.mode == 'edit') {
            this.model = options.model;
        }
        this.organizationCollection = options.organizationCollection;
    },

    onRender: function () {
        var that = this;
        that.organizationsSelectView = new EntitiesSelectView({
            collectionValues: this.organizationCollection,
            customPlaceholder: 'Select a organization',
            entityId: that.model.get('organizationId')
        });
        that.showChildView('organizations', that.organizationsSelectView);
    },

    entitySelected: function (data) {
        this.model.set('organizationId', data.id);
    },

    save: function () {
        this.model.set('name', this.ui.name.val());
        this.model.get('object').signsLimit = this.ui.limit.val();
        this.model.get('object').signX = this.ui.signX.val();
        this.model.get('object').signY = this.ui.signY.val();
        this.model.get('object').signWidth = this.ui.signWidth.val();
        this.model.save(this.model.toJSON(), {success: this.modelSaved});
    },

    modelSaved: function () {
        this.triggerMethod('on:save', null);
    },

    cancel: function () {
        this.triggerMethod('on:cancel', null);
    },

    onKeyPress: function (event) {
        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
            event.charCode >= 48 && event.charCode <= 57;
    }

});

module.exports = DocumentTypeFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/document-types/document-type-form.js
// module id = 454
// module chunks = 0